import { render, staticRenderFns } from "./rubrique_depense.vue?vue&type=template&id=dbb53732&"
import script from "./rubrique_depense.vue?vue&type=script&lang=js&"
export * from "./rubrique_depense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports